import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../../components/Select';
import _ from 'lodash';
import { FUND_FILING_TYPE } from '../../../../services/constant/constant';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import {
    fetchTrustStates,
    fetchPortfolioStates,
    fetchClassStates,
    fetchProspectusStates,
    updateNewFilingPayload,
    clearFilingsData,
    updateSecuritySelected,
    updateSelectedStatesList
} from '../../../../services/redux/employee/filing/actions';
import {
    fetchTrustByClient,
    clearTrustsList
} from '../../../../services/redux/employee/trust/actions';
import {
    fetchPortfolioByTrust,
    clearPortfoliosList
} from '../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassesByPortfolio,
    clearClassesList
} from '../../../../services/redux/employee/classes/actions';
import {
    fetchProspectusByClient,
    clearProspectusesList
} from '../../../../services/redux/employee/prospectus/actions';

class SelectSecurityPanel extends Component {
    componentDidMount() {
        let {
            fetchAllClientInformationData,
            fetchTrustByClient,
            fetchProspectusByClient,
            filing,
            updateNewFilingPayload,
            user
        } = this.props;
        if (
            user &&
            (user.roleName === 'Administrator' || user.roleName === 'Superuser')
        ) {
            fetchAllClientInformationData();
        } else if (user) {
            updateNewFilingPayload({
                ...filing.newFiling,
                clientId: user.clientId
            });
            fetchTrustByClient(user.clientId);
            fetchProspectusByClient(user.clientId);
        }
    }
    componentWillUnmount() {
        let {
            clearTrustsList,
            clearProspectusesList,
            clearPortfoliosList,
            clearClassesList,
            clearFilingsData
        } = this.props;
        clearTrustsList();
        clearProspectusesList();
        clearPortfoliosList();
        clearClassesList();
        clearFilingsData();
    }
    handleSelectChange = (name, value) => {
        let {
            filing,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchProspectusByClient,
            clearTrustsList,
            clearPortfoliosList,
            clearClassesList,
            clearProspectusesList,
            updateNewFilingPayload,
            updateSecuritySelected,
            updateSelectedStatesList,
            fetchTrustStates,
            fetchPortfolioStates,
            fetchClassStates,
            fetchProspectusStates
        } = this.props;

        let selectedSecurity = {
            typeId: '',
            typeName: '',
            id: ''
        };
        let tmpSelected = _.extend({}, filing.newFiling);
        if (value !== null) {
            tmpSelected[name] = value[name];
            selectedSecurity = {
                typeName: name,
                id: value[name]
            };
        } else {
            tmpSelected[name] = '';
        }

        if (name === 'clientId') {
            clearTrustsList();
            clearProspectusesList();
            clearPortfoliosList();
            clearClassesList();
            tmpSelected['trustId'] = '';
            tmpSelected['prospectusId'] = '';
            tmpSelected['portfolioId'] = '';
            tmpSelected['classId'] = '';
            selectedSecurity = {
                typeId: '',
                typeName: '',
                id: ''
            };
            if (value !== null) {
                fetchTrustByClient(value[name]);
                fetchProspectusByClient(value[name]);
            }
        } else if (name === 'trustId') {
            clearPortfoliosList();
            clearClassesList();
            tmpSelected['portfolioId'] = '';
            tmpSelected['classId'] = '';
            if (value !== null) {
                selectedSecurity.typeId = FUND_FILING_TYPE.TRUST;
                fetchPortfolioByTrust(value[name]);
                fetchTrustStates(value[name]);
            }
        } else if (name === 'portfolioId') {
            clearClassesList();
            tmpSelected['classId'] = '';
            if (value !== null) {
                selectedSecurity.typeId = FUND_FILING_TYPE.PORTFOLIO;
                fetchClassesByPortfolio(value[name]);
                fetchPortfolioStates(value[name]);
            }
        } else if (name === 'classId') {
            if (value !== null) {
                selectedSecurity.typeId = FUND_FILING_TYPE.CLASS;
                fetchClassStates(value[name]);
            }
        } else if (name === 'prospectusId') {
            if (value !== null) {
                selectedSecurity.typeId = FUND_FILING_TYPE.PROSPECTUS;
                fetchProspectusStates(value[name]);
            }
        }

        updateSecuritySelected(selectedSecurity);
        updateNewFilingPayload(tmpSelected);
        updateSelectedStatesList([]);
    };

    render() {
        let {
            clientInformation,
            filing,
            trust,
            portfolio,
            classes,
            prospectus,
            user
        } = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 mb">
                        <Select
                            name="clientId"
                            placeholder="Choose a Client"
                            labelKey="name"
                            valueKey="clientId"
                            selectedValue={filing.newFiling.clientId}
                            onChange={this.handleSelectChange}
                            options={clientInformation.clients}
                            disabled={
                                user &&
                                !(
                                    user.roleName === 'Administrator' ||
                                    user.roleName === 'Superuser'
                                )
                            }
                        />
                    </div>
                </div>
                {filing.newFiling.clientId && (
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                name="trustId"
                                placeholder="Choose a Trust"
                                labelKey="name"
                                valueKey="trustId"
                                selectedValue={filing.newFiling.trustId}
                                onChange={this.handleSelectChange}
                                options={trust.trusts}
                                disabled={filing.newFiling.prospectusId}
                            />
                        </div>
                        <div className="col-md-6 mb">
                            <Select
                                name="prospectusId"
                                placeholder="or choose a Prospectus"
                                labelKey="name"
                                valueKey="prospectusId"
                                selectedValue={filing.newFiling.prospectusId}
                                onChange={this.handleSelectChange}
                                options={prospectus.prospectusList}
                                disabled={filing.newFiling.trustId}
                            />
                        </div>
                    </div>
                )}
                {filing.newFiling.trustId && (
                    <div className="row">
                        <div className="col-md-12 mb">
                            <Select
                                name="portfolioId"
                                placeholder="Choose a Portfolio"
                                labelKey="name"
                                valueKey="portfolioId"
                                selectedValue={filing.newFiling.portfolioId}
                                onChange={this.handleSelectChange}
                                options={portfolio.portfolios}
                            />
                        </div>
                    </div>
                )}
                {filing.newFiling.portfolioId && (
                    <div className="row">
                        <div className="col-md-12 mb">
                            <Select
                                name="classId"
                                placeholder="Choose a Class"
                                labelKey="name"
                                valueKey="classId"
                                selectedValue={filing.newFiling.classId}
                                onChange={this.handleSelectChange}
                                options={classes.classes}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    trust: state.employee.trust,
    portfolio: state.employee.portfolio,
    classes: state.employee.classes,
    prospectus: state.employee.prospectus,
    filing: state.employee.filing,
    user: state.authentication.user
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchTrustStates,
            fetchPortfolioStates,
            fetchClassStates,
            fetchProspectusStates,
            fetchAllClientInformationData,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchProspectusByClient,
            clearTrustsList,
            clearPortfoliosList,
            clearClassesList,
            clearProspectusesList,
            updateNewFilingPayload,
            clearFilingsData,
            updateSecuritySelected,
            updateSelectedStatesList
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SelectSecurityPanel));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewFilingRequest/SelectSecurityPanel.js